import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';
import { getTournaments } from '../lib/supabase';

interface Tournament {
  id: string;
  name: string;
  status: string;
  scoring_method?: string;
}

interface TournamentContextValue {
  tournaments: Tournament[];
  selectedTournament: Tournament | null;
  setSelectedTournament: (t: Tournament) => void;
  loading: boolean;
}

const TournamentContext = createContext<TournamentContextValue>({
  tournaments: [],
  selectedTournament: null,
  setSelectedTournament: () => {},
  loading: true,
});

export function TournamentProvider({ children }: { children: ReactNode }) {
  const [tournaments, setTournaments] = useState<Tournament[]>([]);
  const [selectedTournament, setSelectedTournament] = useState<Tournament | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTournaments().then(({ data }) => {
      if (data && data.length > 0) {
        const list = data.map(t => ({ id: t.id, name: t.name, status: t.status, scoring_method: t.scoring_method }));
        setTournaments(list);
        const active = list.find(t => t.status?.toLowerCase() === 'ongoing')
          || list.find(t => t.status?.toLowerCase() === 'active')
          || list.find(t => t.status?.toLowerCase() === 'upcoming')
          || list[0];
        setSelectedTournament(active);
      }
    }).finally(() => setLoading(false));
  }, []);

  return (
    <TournamentContext.Provider value={{ tournaments, selectedTournament, setSelectedTournament, loading }}>
      {children}
    </TournamentContext.Provider>
  );
}

export function useTournament() {
  return useContext(TournamentContext);
}
